import { render, staticRenderFns } from "./TermsOfUseComponent.vue?vue&type=template&id=502cf00c&scoped=true&"
import script from "./TermsOfUseComponent.vue?vue&type=script&lang=js&"
export * from "./TermsOfUseComponent.vue?vue&type=script&lang=js&"
import style0 from "./TermsOfUseComponent.vue?vue&type=style&index=0&id=502cf00c&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502cf00c",
  null
  
)

export default component.exports